import classNames from 'classnames';

import { SanityImage } from '@components/SanityImage';

import { CmsEnquiryForm } from '@interfaces/common';
import { breakpoints } from '@utils/device';

import { SellForm } from './SellForm';
import styles from './SellFormSection.module.css';

export type SellFormSectionProps = Omit<CmsEnquiryForm, '_key' | '_type'>;

export const SellFormSection: React.VFC<SellFormSectionProps> = ({
	image,
	title,
	paragraph,
	formFields,
}) => {
	return (
		<section className={classNames(styles.wrapper, 'stack-block')}>
			<div className={classNames(styles['form-wrapper'], 'stack-block')}>
				<div className={classNames(styles['text-wrapper'], 'stack-block')}>
					<h2 className="fluid-font-t2">{title}</h2>
					<p className="fluid-font-t5">{paragraph}</p>
				</div>

				<SellForm formFields={formFields} />
			</div>

			<div className={styles['image-wrapper']}>
				<SanityImage image={image} sizes={`${breakpoints.lg} 50vw, 100vw`} />
			</div>
		</section>
	);
};
